"use strict";

exports.__esModule = true;
exports.getbaichuanentrance = exports.baichuanpagereport = void 0;
var _fetch = require("../../utils/fetch");
/**
 * 获取百川组件 https://zapi.zhuanspirit.com/project/5588/interface/api/3314625
 */
var getbaichuanentrance = function getbaichuanentrance(params) {
  if (params === void 0) {
    params = {};
  }
  return (0, _fetch.fetch)({
    url: '//app.zhuanzhuan.com/zzopen/npsapi/getbaichuanentrance',
    method: 'post',
    params: params
  }).then(function (res) {
    return res.respData;
  });
};

/**
 * 百川组件上报数据 https://zapi.zhuanspirit.com/project/5588/interface/api/3314383
 */
exports.getbaichuanentrance = getbaichuanentrance;
var baichuanpagereport = function baichuanpagereport(params) {
  if (params === void 0) {
    params = {};
  }
  return (0, _fetch.fetch)({
    url: '/zzopen/npsapi/baichuanpagereport',
    method: 'post',
    params: params
  }).then(function (res) {
    return res.respData;
  });
};
exports.baichuanpagereport = baichuanpagereport;